import {
  getAllDrinksSubcategoryKeywords,
  getDrinksSubcategoryPriority,
  getLocaleAwareSubcategoryKeywords,
} from './languages';
import {
  type SubcategoryConfig,
  type SubcategoryResult,
  detectSubcategory,
} from './subcategoryDetection';
import { EXPENSE_TAXONOMY } from './taxonomy';

export const DRINKS_KEYWORDS = getAllDrinksSubcategoryKeywords();

/** Derived from the canonical `EXPENSE_TAXONOMY`. See taxonomy.ts. */
export const VALID_DRINKS_SUBCATEGORIES =
  EXPENSE_TAXONOMY.drinks as readonly string[] as string[];

export const DRINKS_CONFIG: SubcategoryConfig = {
  keywords: DRINKS_KEYWORDS,
  validSubcategories: VALID_DRINKS_SUBCATEGORIES,
  minConfidenceThreshold: 0.3,
  subcategoryPriority: getDrinksSubcategoryPriority(),
};

export function detectDrinksSubcategory(description: string): string {
  return detectSubcategory(description, DRINKS_CONFIG).subcategory;
}

export function detectDrinksSubcategoryWithConfidence(
  description: string
): SubcategoryResult {
  return detectSubcategory(description, DRINKS_CONFIG);
}

/**
 * Locale-aware drinks subcategory detector. Combines global brand
 * keywords (Starbucks, Heineken, Red Bull, Evian, etc.) with the user's
 * primary-language common words. Returns `default@0` when the locale
 * doesn't resolve so the cloud LLM can step in.
 */
export function detectDrinksSubcategoryWithLocale(
  description: string,
  locale: string | undefined | null
): SubcategoryResult {
  const keywords = getLocaleAwareSubcategoryKeywords(
    b => b.drinksSubcategories,
    k => k.drinksSubcategories,
    locale
  );
  if (!keywords) {
    return { subcategory: 'default', confidence: 0, matchedKeywords: [] };
  }
  return detectSubcategory(description, {
    ...DRINKS_CONFIG,
    keywords,
  });
}
